module.exports = __webpack_public_path__ + "img/Mobility.bca168b1.jpg";